import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { TEXTO_SECUNDARIO, GRADE, PALETA_CATEGORICA } from './paletaResultados';

const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

function formatarPeriodo(periodo, granularidade) {
  if (granularidade === 'mensal') {
    const [ano, mes] = periodo.split('-');
    return `${MESES[Number(mes) - 1]}/${ano}`;
  }
  const [, mes, dia] = periodo.split('-');
  return `${dia}/${mes}`;
}

// Votos ao longo do tempo — nível da enquete inteira, não por pergunta (fica
// no topo da tela de resultados). Granularidade decidida no backend pela
// duração real da coleta (até 60 dias = diário, acima = mensal — ver
// resultadosService.js). Série única: sem legenda (o título do card já diz
// o que é), com área leve sob a linha pra reforçar volume.
const GraficoLinhaTemporal = ({ serieTemporal }) => {
  const pontos = serieTemporal?.pontos || [];
  if (pontos.length === 0) {
    return <p className="text-sm text-gray-400 italic py-6 text-center">Nenhum voto registrado ainda.</p>;
  }

  const granularidade = serieTemporal.granularidade;
  const dados = [{
    id: 'votos',
    data: pontos.map((p) => ({ x: formatarPeriodo(p.periodo, granularidade), y: p.total }))
  }];

  return (
    <div style={{ height: 260 }}>
      <ResponsiveLine
        data={dados}
        margin={{ top: 16, right: 24, bottom: 44, left: 44 }}
        xScale={{ type: 'point' }}
        yScale={{ type: 'linear', min: 0, max: 'auto', nice: true }}
        curve="monotoneX"
        colors={[PALETA_CATEGORICA[0]]}
        lineWidth={2}
        enableArea
        areaOpacity={0.1}
        pointSize={pontos.length > 30 ? 0 : 6}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        axisBottom={{
          tickSize: 0,
          tickPadding: 10,
          tickRotation: pontos.length > 10 ? -30 : 0,
          tickValues: pontos.length > 14 ? Math.min(10, pontos.length) : undefined
        }}
        axisLeft={{ tickSize: 0, tickPadding: 8 }}
        enableGridX={false}
        gridYValues={4}
        theme={{
          grid: { line: { stroke: GRADE, strokeWidth: 1 } },
          axis: { ticks: { text: { fill: TEXTO_SECUNDARIO, fontSize: 11 } } }
        }}
        useMesh
        enableSlices="x"
        animate
        motionConfig="gentle"
        role="img"
        ariaLabel="Gráfico de linha com votos ao longo do tempo"
        sliceTooltip={({ slice }) => {
          const ponto = slice.points[0];
          return (
            <div className="bg-white shadow-lg rounded-lg pl-2.5 pr-3.5 py-2 border border-gray-100 flex items-stretch gap-2.5">
              <span className="w-[3px] rounded-full flex-shrink-0" style={{ backgroundColor: ponto.seriesColor }} />
              <div>
                <p className="text-base font-semibold text-gray-900 leading-tight">
                  {ponto.data.yFormatted} <span className="text-xs font-normal text-gray-400">voto(s)</span>
                </p>
                <p className="text-xs text-gray-500">{ponto.data.xFormatted}</p>
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default GraficoLinhaTemporal;
